<template>
    <component :is="template" v-bind="$props" @toggleDetails="toggleDetails"></component>
</template>
<script>
  import Vue from 'vue';
  import MatchOddComponent from '../../common/match/match-odd-component';
  import MatchExpandedOddComponent from '../../common/match/match-expanded-odd-component';
  import EmbededMatchDetails from '../match-details/prematch/embeded-match-details';
  import FavoriteComponent from '../../shared/favorite-component';
  import StatisticsComponent from '../../common/statistics-component';
  import OddHelperService from '../../../services/odd-helper-service';
  import store from '../../../store';
  import { urlFriendlyParam } from '@bto-services/utils';

  import MatchListItemTpl from './tpl/match-list-item';
  import MatchListItemLatamTpl from './tpl/match-list-item-latam';
  import MatchListProps from './match-list-props';


  Vue.component('MatchOddComponent', MatchOddComponent);
  Vue.component('MatchExpandedOddComponent', MatchExpandedOddComponent);
  Vue.component('EmbededMatchDetails', EmbededMatchDetails);
  Vue.component('FavoriteComponent', FavoriteComponent);
  Vue.component('StatisticsComponent', StatisticsComponent);


  export default {
    name: 'MatchListItemCl',
    components: {
      MatchListItemTpl,
      MatchListItemLatamTpl,
    },
    props: MatchListProps,
    data() {
      return {
        matchExpanded: false,
        showStatistics: APP_SETTINGS.category.showStatistics,
        showEventCode: APP_SETTINGS.category.showEventCode,
        SHOW_NUMBER_OF_MARKETS: APP_SETTINGS.category.showNumberOfMarkets,
        showTeamIcon: APP_SETTINGS.category.showTeamIcon,
      };
    },
    computed: {
      cashoutEnabledDB() {
        return store.getters.getCashoutDbSetting;
      },
      template() {
        return this.useLatam ? MatchListItemLatamTpl : MatchListItemTpl;
      },

      /**
       * cash out visibility on tournament level
       */
      cashoutEnabledUser() {
        return store.state.playerInfoModule.playerInfo.cashout;
      },
      cashOutVisibility() {
        return this.cashoutEnabledDB && this.match.cashOutVisibility &&
          (!APP_SETTINGS.player.token || this.cashoutEnabledUser);
      },
      eventDescription() {
        let str = `${APP_SETTINGS.category.showCategoryName ? this.match.categoryName : ''}`;
        str += `${APP_SETTINGS.category.showCategoryName && APP_SETTINGS.category.showTournamentName ? ' - ' : ''}`;
        str += `${APP_SETTINGS.category.showTournamentName ? this.match.tournamentName : ''}`;
        return str;
      },
      firstCol() {
        // if there are no outcomes for the column add empty outcomes
        return this.match.odds[0] && this.match.odds[0].outcomes.length > 0 ?
          this.match.odds[0] :
          OddHelperService.generateEmptyOutcomes(this.is3WaySport ? 3 : 2, false);
      },
      secondCol() {
        if (typeof this.combiMainMarkets !== 'object' || !this.combiMainMarkets[1]) {
          return {};
        }
        let firstComboOddType = this.combiMainMarkets[1].find(c => c.n === this.firstCombiSelected) || {};
        if (typeof firstComboOddType.o === 'undefined') {
          return {};
        }
        return OddHelperService.getOrderedOutcomes(this.firstCombiOdds[this.match.matchId], firstComboOddType);
      },
      thirdCol() {
        if (typeof this.combiMainMarkets !== 'object' || !this.combiMainMarkets[2]) {
          return {};
        }
        let secondComboOddType = this.combiMainMarkets[2].find(c => c.n === this.secondCombiSelected) || {};
        if (typeof secondComboOddType.o === 'undefined') {
          return {};
        }
        return OddHelperService.getOrderedOutcomes(this.secondCombiOdds[this.match.matchId], secondComboOddType);
      },
    },
    methods: {
      getOrderedOutcomes(column) {
        return OddHelperService.orderColumnOutcomes(this.singleMarketOdds.outcomes, column);
      },
      toggleDetails() {
        this.matchExpanded = !this.matchExpanded;
      },
      openMatchDetails(match) {
        const rawSportName = store.getters.getSportName(match.sportId);
        const sportName = urlFriendlyParam(rawSportName);
        const eventName = urlFriendlyParam(`${match.homeTeam} vs ${match.guestTeam}`);
        const categoryName = urlFriendlyParam(match.tournamentName);
        return {
          name: 'seoGame',
          params: {
            sportName,
            categoryName,
            eventName,
            matchId: match.matchId
          }
        };
      },
      generateEmptyOdd() {
        return OddHelperService.generateEmptyOutcomes(1, false).outcomes[0];
      },
      genarateOutcomeDisplay(match, ID) {
        return match.odds[0].outcomes[ID] || this.generateEmptyOdd();
      }
    },
  };
</script>
